import React from "react";


function Contact() {
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/temple.webp)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>

        <div className="row">
          <div className="col-md-5" style={{ background: '#ffffffff', padding: '50px' }}>
            <div className="row" style={{ borderBottom: '0px solid orange', paddingBottom: '15px', paddingTop: '15px' }}>
              <h3 className="cheading" >Address</h3>
              {/* first */}
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-map-marker contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  {/* <p className="addr">Borivali Sree Ayyappa Temple,  <br />
                    Sree Ayyappa Seva Sangham – Saibaba Nagar (Regd.) <br />
                    Temple Complex, Ram Nagar, <br />
                    Borival, West, Mumbai – 400092</p> */}
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-phone-square contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  {/* <p className="addr">022-28091743</p> */}
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-envelope contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  {/* <p className="addr">ayyappatempleborivli@gmail.com</p> */}
                </div>
              </div>

            </div>
          </div>
          <div className="col-md-7" style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2009735.074064624!2d74.76261106032851!3d10.320759438947633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba46c4c678639b1%3A0xe48a41b8553ca11d!2sSree%20Subrahmanya%20Swami%20Temple%20Payyanur!5e0!3m2!1sen!2sin!4v1776008908434!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>



          </div>
        </div>


      </div>
    </div>
  );
}

export default Contact;

